var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveSegment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 14,
    viewBox: "0 0 47 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55798 3.57003C4.66366 2.43344 2.20662 3.0477 1.07003 4.94202C-0.0665637 6.83634 0.547697 9.29338 2.44202 10.43L6.55798 3.57003ZM24.5 7L22.442 3.57003C17.5536 6.50311 11.4465 6.50311 6.55798 3.57003L4.5 7L2.44202 10.43C9.86395 14.8831 19.1361 14.8831 26.558 10.43L24.5 7ZM24.5 7L26.558 10.43C31.4465 7.49689 37.5536 7.49689 42.442 10.43L44.5 7L46.558 3.57003C39.1361 -0.883128 29.8639 -0.883127 22.442 3.57003L24.5 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSegment);
export default __webpack_public_path__ + "static/media/waveSegment.34754486f7385340dde4500b6953744c.svg";
export { ForwardRef as ReactComponent };